import React, { useState, useEffect } from 'react';
import { prizeService, authService } from '../services';
import BackButton from '../components/BackButton';

function Prizes() {
  const [prizes, setPrizes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [redeeming, setRedeeming] = useState(null);
  const isAuthenticated = authService.isAuthenticated();

  useEffect(() => {
    loadPrizes();
  }, []);

  const loadPrizes = async () => {
    try {
      const data = await prizeService.getAllPrizes();
      setPrizes(data);
    } catch (err) {
      setError('加载奖品失败');
    } finally {
      setLoading(false);
    }
  };

  const handleRedeem = async (prizeId, prizeName) => {
    if (!isAuthenticated) {
      setError('请先登录以兑换奖品');
      return;
    }

    if (!window.confirm(`确定要兑换 "${prizeName}" 吗？`)) {
      return;
    }

    setRedeeming(prizeId);
    setError('');
    setSuccess('');

    try {
      const result = await prizeService.redeemPrize(prizeId);
      setSuccess(`成功兑换 "${prizeName}"！剩余积分：${result.remainingPoints}`);
      
      // Update local user points
      const user = authService.getCurrentUser();
      if (user) {
        user.points = result.remainingPoints;
        localStorage.setItem('user', JSON.stringify(user));
      }
      
      // Reload prizes to update stock
      loadPrizes();
      
      // Note: For better UX, consider using React Context or state management
      // to update navbar points without page reload
    } catch (err) {
      setError(err.response?.data?.message || '兑换失败');
    } finally {
      setRedeeming(null);
    }
  };

  if (loading) {
    return <div className="loading">正在加载奖品...</div>;
  }

  return (
    <div className="container">
      <BackButton to="/" />
      <h1 className="page-title">积分兑换</h1>
      <p className="page-subtitle">用你的积分兑换专属礼物吧！</p>

      {error && <div className="form-error" style={{ maxWidth: '600px', margin: '0 auto 2rem' }}>{error}</div>}
      {success && <div className="form-success" style={{ maxWidth: '600px', margin: '0 auto 2rem' }}>{success}</div>}

      {prizes.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">🎁</div>
          <p>暂无奖品</p>
        </div>
      ) : (
        <div className="grid">
          {prizes.map((prize) => (
            <div key={prize.id} className="card prize-card">
              <img 
                src={prize.image_url || 'https://via.placeholder.com/300x200/9b59b6/ffffff?text=Prize'} 
                alt={prize.name}
                className="card-image"
              />
              <h3 className="card-title">{prize.name}</h3>
              <p className="card-description">{prize.description}</p>
              <div className="prize-cost">⭐ {prize.cost} 积分</div>
              <div className="prize-stock">
                {prize.stock > 0 ? `库存: ${prize.stock}` : '缺货'}
              </div>
              <button 
                className="btn btn-primary" 
                onClick={() => handleRedeem(prize.id, prize.name)}
                disabled={prize.stock <= 0 || redeeming === prize.id || !isAuthenticated}
              >
                {redeeming === prize.id ? '兑换中...' : '兑换'}
              </button>
              {!isAuthenticated && (
                <p style={{ color: 'var(--text-light)', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                  登录以兑换
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Prizes;
